// src/data/Menu.js

// Dashboard Menu
// export const dashboardMenu = [
//   {
//     "label": "Tableau de bord",
//     "link": "/dashboard/finance",
//     "icon": "ri-dashboard-line"
//   },
//   {
//     "label": "Chiffre d'affaires",
//     "link": "/dashboard/ca",
//     "icon": "ri-line-chart-line"
//   },
//   {
//     "label": "Ventes du jour",
//     "link": "/dashboard/ventes-jour",
//     "icon": "ri-shopping-bag-3-line"
//   },
//   {
//     "label": "Stock critique",
//     "link": "/dashboard/stock-critique",
//     "icon": "ri-error-warning-line"
//     // Le badge sera ajouté dynamiquement dans le composant Sidebar
//   },
//   {
//     "label": "Commandes en cours",
//     "link": "/dashboard/commandes",
//     "icon": "ri-truck-line"
//   },
//   {
//     "label": "Factures impayées",
//     "link": "/dashboard/impayes",
//     "icon": "ri-error-warning-line"
//     // Le badge sera ajouté dynamiquement dans le composant Sidebar
//   }
// ];





// src/data/Menu.js - Ajouter dans le fichier existant

// RH Menu (Ressources Humaines)
export const rhMenu = [
    {
        "label": "Contrats",
        "icon": "ri-file-copy-line",
        "submenu": [
            {
                "label": "Nouveau contrat",
                "link": "/rh/contratsNouveau"
            },
            {
                "label": "Liste des contrats",
                "link": "/rh/contrats"
            },
            {
                "label": "Alertes",
                "link": "/rh/contratsAlertes"
            }
        ]
    },
    {
        "label": "Employés",
        "icon": "ri-group-line",
        "submenu": [
            {
                "label": "Liste des employés",
                "link": "/rh/employes"
            },
            {
                "label": "Ajouter un employé",
                "link": "/rh/employesAjouter"
            }
        ]
    }
];

// Caisse Menu
export const caisseMenu = [
    {
        "label": "Décaissements",
        "icon": "ri-bank-card-line",
        "submenu": [
            {
                "label": "Nouv. décaissement",
                "link": "/caisse/decaissement"
            },
            {
                "label": "Historique",
                "link": "/caisse/operations"
            },
            {
                "label": "Statistiques",
                "link": "/caisse/stats"
            }
        ]
    }
];

// Ajouter aux exports existants


// export const ventesMenu = [
//   {
//     "label": "Clients",
//     "icon": "ri-group-line",
//     "submenu": [
//       {
//         "label": "Liste des clients",
//         "link": "/ventes/clients/liste"
//       },
//       {
//         "label": "Ajouter un client",
//         "link": "/ventes/clients/ajouter"
//       },
      
//       {
//         "label": "Import/Export",
//         "link": "/ventes/clients/import"
//       }
//     ]
//   },
//   {
//     "label": "Factures",
//     "icon": "ri-file-list-3-line",
//     "submenu": [
//       {
//         "label": "Nouvelle facture",
//         "link": "/ventes/factures/nouveau"
//       },
//       {
//         "label": "Liste des factures",
//         "link": "/ventes/factures/liste"
//       },
//       {
//         "label": "Factures impayées",
//         "link": "/ventes/factures/impayees"
//       },
//       {
//         "label": "Avoirs",
//         "link": "/ventes/avoirs"
//       }
//     ]
//   },
//   {
//     "label": "Devis / Proformas",
//     "icon": "ri-file-copy-line",
//     "submenu": [
//       {
//         "label": "Nouveau devis",
//         "link": "/ventes/devis/nouveau"
//       },
//       {
//         "label": "Liste des devis",
//         "link": "/ventes/devisListe"
//       },
//       // {
//       //   "label": "Devis acceptés",
//       //   "link": "/ventes/devis/acceptes"
//       // }
//     ]
//   },
//   {
//     "label": "Bons de livraison",
//     "icon": "ri-truck-line",
//     "submenu": [
//       {
//         "label": "Nouveau BL",
//         "link": "/ventes/bl/nouveau"
//       },
//       {
//         "label": "Liste des BL",
//         "link": "/ventes/blListe"
//       },
//       {
//         "label": "BL à livrer",
//         "link": "/ventes/bl/en-cours"
//       }
//     ]
//   },
//   {
//     "label": "Règlements",
//     "icon": "ri-bank-card-line",
//     "submenu": [
//       {
//         "label": "Saisir un règlement",
//         "link": "/ventes/NouveauReglement"
//       },
//       {
//         "label": "Liste des règlements",
//         "link": "/ventes/reglements"
//       },
//       {
//         "label": "Échéancier",
//         "link": "/ventes/reglementsEcheancier"
//       }
//     ]
//   }
// ];

// export const achatsMenu = [
//   {
//     "label": "Fournisseurs",
//     "icon": "ri-truck-line",
//     "submenu": [
//       {
//         "label": "Liste des fournisseurs",
//         "link": "/achats/fournisseurs"
//       },
//       {
//         "label": "Ajouter un fournisseur",
//         "link": "/achats/fournisseursAjouter"
//       },
//       {
//         "label": "Évaluation",
//         "link": "/achats/fournisseursEvaluation"
//       }
//     ]
//   },
//   {
//     "label": "Commandes",
//     "icon": "ri-shopping-cart-line",
//     "submenu": [
//       {
//         "label": "Nouvelle commande",
//         "link": "/achats/commandesNouveau"
//       },
//       {
//         "label": "Commandes",
//         "link": "/achats/commandes"
//       },
//       {
//         "label": "Commandes en cours",
//         "link": "/achats/commandesCours"
//       },
//       {
//         "label": "Commandes reçues",
//         "link": "/achats/commandesRecues"
//       },
//       {
//         "label": "Historique",
//         "link": "/achats/commandesHistorique"
//       }
//     ]
//   }
 
// ];

// export const stockMenu = [
//   {
//     "label": "Produits",
//     "icon": "ri-suitcase-2-line",
//     "submenu": [
//       {
//         "label": "Liste des produits",
//         "link": "/stock/produits"
//       },
//       {
//         "label": "Ajouter un produit",
//         "link": "/stock/produitsAjouter"
//       },
//       {
//         "label": "Catégories",
//         "link": "/stock/produitsCategories"
//       },
//       {
//         "label": "Import/Export",
//         "link": "/stock/produits/import"
//       }
//     ]
//   },
//   {
//   "label": "État du stock",
//   "icon": "ri-pie-chart-2-line",
//   "submenu": [
//     {
//       "label": "Stock instantané",
//       "link": "/stock/etat/instantane",
//       "description": "Niveaux de stock en temps réel"
//     },
//     {
//       "label": "Mouvements de stock",
//       "link": "/stock/etat/mouvements",
//       "description": "Historique des entrées/sorties"
//     },
//     {
//       "label": "Valeur du stock",
//       "link": "/stock/etat/valeur",
//       "description": "Évaluation financière"
//     },
//     {
//       "label": "Stock critique",
//       "link": "/stock/etat/critique",
//       "description": "Produits sous seuil d'alerte"
//     }
//   ]
// },
//   // {
//   //   "label": "Alertes",
//   //   "icon": "ri-alert-line",
//   //   "submenu": [
//   //     {
//   //       "label": "Stock critique",
//   //       "link": "/stock/alertes/critique"
//   //     },
//   //     {
//   //       "label": "Rupture",
//   //       "link": "/stock/alertes/rupture"
//   //     },
//   //     {
//   //       "label": "Surstock",
//   //       "link": "/stock/alertes/surstock"
//   //     }
//   //   ]
//   // },

//    {
//     "label": "Scanner codes-barres", // NOUVEAU
//     "link": "/stock/scanner",
//     "icon": "ri-qr-code-line"
//   },
//  {
//   "label": "Inventaire",
//   "icon": "ri-clipboard-line",
//   "link": "/stock/inventaire"
// },
//   {
//     "label": "Traçabilité",
//     "icon": "ri-search-eye-line",
//     "link": "/stock/tracabilite"
//   }
// ];

// export const statistiquesMenu = [
// {
//   "label": "Statistiques",
//   "icon": "ri-bar-chart-2-line",
//   "submenu": [
//     {
//       "label": "Tableau de bord",
//       "link": "/stats/dashboard",
//       "icon": "ri-dashboard-line"
//     },
//     {
//       "label": "Chiffre d'affaires",
//       "link": "/stats/ventes/ca",
//       "icon": "ri-money-euro-circle-line"
//     },
//     {
//       "label": "Évolution mensuelle",
//       "link": "/stats/ventes/mensuel",
//       "icon": "ri-calendar-line"
//     },
//     {
//       "label": "Top produits",
//       "link": "/stats/ventes/top-produits",
//       "icon": "ri-star-line"
//     },
//     {
//       "label": "Top clients",
//       "link": "/stats/ventes/top-clients",
//       "icon": "ri-group-line"
//     },
//     {
//       "label": "Dépenses achats",
//       "link": "/stats/achats/depenses",
//       "icon": "ri-shopping-cart-2-line"
//     },
//     {
//       "label": "Top fournisseurs",
//       "link": "/stats/achats/fournisseurs",
//       "icon": "ri-truck-line"
//     },
//     {
//       "label": "Rotation stock",
//       "link": "/stats/stock/rotation",
//       "icon": "ri-refresh-line"
//     }
//   ]
// },
//   // {
//   //   "label": "Achats",
//   //   "icon": "ri-shopping-cart-2-line",
//   //   "submenu": [
//   //     {
//   //       "label": "Dépenses",
//   //       "link": "/stats/achats/depenses"
//   //     },
//   //     {
//   //       "label": "Top fournisseurs",
//   //       "link": "/stats/achats/fournisseurs"
//   //     }
//   //   ]
//   // },
//   // {
//   //   "label": "Stock",
//   //   "icon": "ri-hard-drive-2-line",
//   //   "submenu": [
//   //     {
//   //       "label": "Rotation",
//   //       "link": "/stats/stock/rotation"
//   //     },
//   //     {
//   //       "label": "Valeur",
//   //       "link": "/stats/stock/valeur"
//   //     }
//   //   ]
//   // },
//   {
//     "label": "Finances",
//     "icon": "ri-money-euro-circle-line",
//     "submenu": [
//       {
//         "label": "Trésorerie",
//         "link": "/stats/finances/tresorerie"
//       },
//       {
//         "label": "Encours clients",
//         "link": "/stats/finances/encours"
//       }
//     ]
//   }
// ];

export const parametresMenu = [
  {
    "label": "Société",
    "icon": "ri-building-line",
    "link": "/parametres/societe/infos"
    // "submenu": [
      // {
      //   "label": "Informations",
      //   "link": "/parametres/societe/infos"
      // },
      // {
      //   "label": "Taxes (TVA/CSS)",
      //   "link": "/parametres/societe/taxes"
      // }
    // ]
  },
  {
    "label": "Utilisateurs",
    "icon": "ri-user-settings-line",
    "link": "/parametres/utilisateurs"
    // "submenu": [
      // {
      //   "label": "Liste des utilisateurs",
      //   "link": "/parametres/utilisateurs"
      // },
      // {
      //   "label": "Rôles & permissions",
      //   "link": "/parametres/utilisateursRoles"
      // }
    // ]
  },
  // {
  //   "label": "Documents",
  //   "icon": "ri-printer-line",
  //   "submenu": [
      
  //     {
  //       "label": "Numérotation",
  //       "link": "/parametres/documents/numerotation"
  //     }
  //   ]
  // },
  // {
  //   "label": "Sauvegarde",
  //   "icon": "ri-database-2-line",
  //   "submenu": [
  //     {
  //       "label": "Sauvegarder",
  //       "link": "/parametres/sauvegarde/manuel"
  //     },
  //     {
  //       "label": "Restaurer",
  //       "link": "/parametres/sauvegarde/restauration"
  //     }
  //   ]
  // }
];




// Dans votre menu stock existant, ajoutez :
// export const appsMenu = [
 
 
// ];

// Export de tous les menus
// export { 
//   dashboardMenu, 
//   ventesMenu, 
//   achatsMenu, 
//   stockMenu, 
//   statistiquesMenu, 
//   parametresMenu, 
//   appsMenu 
// };